import { Button, Drawer, Navbar, Sidebar } from 'flowbite-react';
import React, { useEffect, useState, useRef } from 'react';
import LogoComponent from '../components/LogoComponent';
import { FiMenu, FiX } from 'react-icons/fi';
import DarkModeToggle from '../components/DarkModeToggle';
import TruncatedText from '../components/TruncatedText';
import { useLocation, useNavigate } from 'react-router-dom';
import { IoIosArrowDown } from "react-icons/io";
// import StyledText from '../components/styledText';
import YouTube from 'react-youtube';
import { toast } from 'react-toastify';
import { logo, name, serverURL } from '../constants';
import axios from 'axios';
import { IoChatbubbleEllipses } from "react-icons/io5";
import { FaCheck } from "react-icons/fa";
import { TbReload } from "react-icons/tb";
import { FaRegEdit } from "react-icons/fa";
import { RxReset } from "react-icons/rx";
import { VscSaveAs } from "react-icons/vsc";
import { MdOutlineQuiz } from "react-icons/md";
import { FaRegWindowClose } from "react-icons/fa";
import { IoSend } from "react-icons/io5";
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import html2pdf from 'html2pdf.js';
import { HiDownload } from "react-icons/hi";
import '../App.css';
import Quiz from '../components/quiz';
import RegenerateModal from '../components/RegenerateModal';
const Course = () => {

    const [isOpen, setIsOpen] = useState(false);
    const [key, setkey] = useState('');
    const { state } = useLocation();
    const { mainTopic, type, courseId, end } = state || {};
    const jsonData = JSON.parse(sessionStorage.getItem('jsonData'));
    const storedTheme = sessionStorage.getItem('darkMode');
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [selected, setSelected] = useState('');
    const [theory, setTheory] = useState('');
    const [urlrefference, setUrlreference] = useState('');
    const [media, setMedia] = useState('');
    const [percentage, setPercentage] = useState(0);
    const [isComplete, setIsCompleted] = useState(false);
    const navigate = useNavigate();
    const [messages, setMessages] = useState([]);
    const [newMessage, setNewMessage] = useState('');
    const [isOpenDrawer, setIsOpenDrawer] = useState(false);
    const handleOnClose = () => setIsOpenDrawer(false);
    const [isEditEnabled, setIsEditEnabled] = useState(false);
    const [quizQuestions, setQuizQuestions] = useState([]);
    const [showQuiz, setShowQuiz] = useState(false);
    const scrollRef = useRef(null);
    const [isRegenerateModalOpen, setIsRegenerateModalOpen] = useState(false);

    async function htmlDownload() {
        const id = toast.loading("Please wait, exporting...");

        try {
            // Ensure data is loaded
            await ensureDataIsLoaded();

            // Add a small delay to allow for any last-minute rendering
            await new Promise(resolve => setTimeout(resolve, 500));

            // Generate the combined HTML content
            const combinedHtml = await getCombinedHtml(mainTopic, jsonData[mainTopic.toLowerCase()]);

            // Create a temporary div element
            const tempDiv = document.createElement('div');
            tempDiv.style.width = '100%';
            tempDiv.style.height = '100%';
            tempDiv.innerHTML = combinedHtml;
            document.body.appendChild(tempDiv);

            // Check if content is present
            if (tempDiv.innerHTML.trim() === '') {
                throw new Error('No content to generate PDF');
            }

            // Create the PDF options
            const options = {
                filename: `${mainTopic}.pdf`,
                image: { type: 'jpeg', quality: 1 },
                html2canvas: {
                    scale: 2,
                    logging: false,
                    scrollX: 0,
                    scrollY: 0,
                    useCORS: true
                },
                jsPDF: { unit: 'pt', format: 'a4', orientation: 'portrait' }
            };

            // Generate the PDF
            await html2pdf().from(tempDiv).set(options).save();

            // Clean up
            document.body.removeChild(tempDiv);

            // Update toast
            toast.update(id, {
                render: "PDF generated successfully!",
                type: "success",
                isLoading: false,
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true
            });

        } catch (error) {
            console.error('Error in htmlDownload:', error);

            // Update toast with error message
            toast.update(id, {
                render: `Error: ${error.message}`,
                type: "error",
                isLoading: false,
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true
            });

        } finally {
            // Any cleanup code that should run regardless of success or failure
        }
    }

    function addTargetBlankToLinks(html) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        doc.querySelectorAll('a').forEach(link => {
            link.setAttribute('target', '_blank');
            link.setAttribute('rel', 'noopener noreferrer');
        });

        return doc.body.innerHTML;
    }

    // Helper function to ensure data is loaded
    async function ensureDataIsLoaded() {
        // Implement your logic here to check if data is loaded
        // For example:
        if (!jsonData || Object.keys(jsonData).length === 0) {
            throw new Error('Data not loaded');
        }
    }
    

    // Helper function to get combined HTML
    async function getCombinedHtml(mainTopic, topicData) {
        // Implement your logic here to generate the combined HTML
        // This is a placeholder implementation
        let html = `<h1>${mainTopic}</h1>`;
        for (const subtopic of topicData.subtopics) {
            html += `<h2>${subtopic.title}</h2>`;
            if (subtopic.theory) {
                html += subtopic.theory;
            }
            if (subtopic.image) {
                html += `<img src="${subtopic.image}" alt="${subtopic.title}">`;
            }
        }
        return html;
    }

    const generateQuiz = async () => {
        const id = toast.loading("Generating quiz...");
        const prompt = `Generate a 5-question multiple-choice quiz from theory: "${theory}". Each question should have 4 options and one correct answer. Format the response as a JSON array of objects, each with properties: question, options (an array of 4 strings), and correctAnswer (index of the correct option).`;

        try {
            const response = await axios.post(`${serverURL}/api/generate`, { prompt });
            console.log('API Response:', response.data); // Log the raw response

            let quizData;
            try {
                // Extract JSON from HTML tags
                const jsonString = response.data.text.match(/<code.*?>([\s\S]*?)<\/code>/i)[1];
                quizData = JSON.parse(jsonString);
                console.log('Parsed JSON:', quizData);
            } catch (parseError) {
                console.error('Error parsing JSON:', parseError);
                console.log('Response that caused error:', response.data.text);
                throw new Error('Invalid response format');
            }

            if (!Array.isArray(quizData) || quizData.length !== 5) {
                throw new Error('Unexpected quiz data format');
            }
            setQuizQuestions(quizData);
            setShowQuiz(true);
            toast.update(id, { render: "Quiz generated!", type: "success", isLoading: false, autoClose: 3000 });
        } catch (error) {
            console.error('Error generating quiz:', error);
            let errorMessage = 'Failed to generate quiz';
            if (error.response) {
                console.error('Error response:', error.response.data);
                errorMessage += `: ${error.response.status} ${error.response.statusText}`;
            } else if (error.request) {
                console.error('No response received:', error.request);
                errorMessage += ': No response from server';
            } else {
                console.error('Error details:', error.message);
                errorMessage += `: ${error.message}`;
            }
            toast.update(id, { render: errorMessage, type: "error", isLoading: false, autoClose: 5000 });
        }
    };

    async function getCombinedHtml(mainTopic, topics) {


        async function toDataUrl(url) {
            return new Promise((resolve, reject) => {
                const xhr = new XMLHttpRequest();

                xhr.onload = function () {
                    const reader = new FileReader();
                    reader.onloadend = function () {
                        resolve(reader.result);
                    };
                    reader.readAsDataURL(xhr.response);
                };

                xhr.onerror = function () {
                    reject({
                        status: xhr.status,
                        statusText: xhr.statusText,
                    });
                };

                xhr.open("GET", url);
                xhr.responseType = "blob";
                xhr.send();
            }).catch(error => {
                return '';
            });
        }

        const topicsHtml = topics.map(topic => `
            <h3 style="font-size: 18pt; font-weight: bold; margin: 0; margin-top: 15px;">${topic.title}</h3>
            ${topic.subtopics.map(subtopic => `
                <p style="font-size: 16pt; margin-top: 10px;">${subtopic.title}</p>
            `).join('')}
        `).join('');

        const theoryPromises = topics.map(async topic => {
            const subtopicPromises = topic.subtopics.map(async (subtopic, index, array) => {
                const imageUrl = type === 'text & image course' ? await toDataUrl(subtopic.image) : '';
                if (subtopic.done) {
                    return `
                    <div class="html2pdf__page-break"> 
                        <p style="font-size: 16pt; margin-top: 20px; font-weight: bold;">
                            ${subtopic.title}
                        </p>
                        <div style="font-size: 12pt; margin-top: 15px; ">
                        ${type === 'text & image course'
                            ? (imageUrl ? `<img style="margin-top: 10px;" src="${imageUrl}">` : '')
                            : `<a style="color: #0000FF;" href="https://www.youtube.com/watch?v=${subtopic.youtube}" target="_blank" rel="noopener noreferrer">Watch the YouTube video on ${subtopic.title}</a>`}
                            <div style="margin-top: 10px;">${subtopic.theory}</div>
                        </div>
                    </div>
                `;
                } else {
                    return `
                    <div class="html2pdf__page-break"> 
                        <p style="font-size: 16pt; margin-top: 20px; font-weight: bold;">
                            ${subtopic.title}
                        </p>
                        <div style="font-size: 12pt; margin-top: 15px; ">
                            <div style="margin-top: 10px;">Please visit ${subtopic.title} topic to export as PDF. Only topics that are completed will be added to the PDF.</div>
                        </div>
                    </div>
                `;
                }
            });
            const subtopicHtml = await Promise.all(subtopicPromises);
            return `
                <div style="margin-top: 30px;">
                    <h3 style="font-size: 18pt; text-align: center; font-weight: bold; margin: 0;">
                        ${topic.title}
                    </h3>
                    ${subtopicHtml.join('')}
                </div>
            `;
        });
        const theoryHtml = await Promise.all(theoryPromises);

        return `
        <div class="html2pdf__page-break" 
             style="display: flex; align-items: center; justify-content: center; text-align: center; margin: 0 auto; max-width: 100%; height: 11in;">
            <h1 style="font-size: 30pt; font-weight: bold; margin: 0;">
                ${mainTopic}
            </h1>
        </div>
        <div class="html2pdf__page-break" style="text-align: start; margin-top: 30px; margin-right: 16px; margin-left: 16px;">
            <h2 style="font-size: 24pt; font-weight: bold; margin: 0;">Index</h2>
            <br>
            <hr>
            ${topicsHtml}
        </div>
        <div style="text-align: start; margin-right: 16px; margin-left: 16px;">
            ${theoryHtml.join('')}
        </div>
        `;
    }

    const CountDoneTopics = () => {
        let doneCount = 0;
        let totalTopics = 0;

        jsonData[mainTopic.toLowerCase()].forEach((topic) => {

            topic.subtopics.forEach((subtopic) => {

                if (subtopic.done) {
                    doneCount++;
                }
                totalTopics++;
            });
        });
        const completionPercentage = Math.round((doneCount / totalTopics) * 100);
        setPercentage(completionPercentage);
        if (completionPercentage >= '100') {
            setIsCompleted(true);
        }
    }

    const opts = {
        height: '390',
        width: '640',
    };

    const optsMobile = {
        height: '250px',
        width: '100%',
    };

    async function finish() {
        if (sessionStorage.getItem('first') === 'true') {
            if (!end) {
                const today = new Date();
                const formattedDate = today.toLocaleDateString('en-GB');
                navigate('/certificate', { state: { courseTitle: mainTopic, end: formattedDate } });
            } else {
                navigate('/certificate', { state: { courseTitle: mainTopic, end: end } });
            }

        } else {
            const dataToSend = {
                courseId: courseId
            };
            try {
                const postURL = serverURL + '/api/finish';
                const response = await axios.post(postURL, dataToSend);
                if (response.data.success) {
                    const today = new Date();
                    const formattedDate = today.toLocaleDateString('en-GB');
                    sessionStorage.setItem('first', 'true');
                    sendEmail(formattedDate);
                } else {
                    finish()
                }
            } catch (error) {
                finish()
            }
        }
    }

    async function sendEmail(formattedDate) {
        const userName = sessionStorage.getItem('mName');
        const email = sessionStorage.getItem('email');
        const html = `<!DOCTYPE html>
        <html lang="en">
        <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="initial-scale=1.0">
            <title>Certificate of Completion</title>
            <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700;900&display=swap">
            <style>
            body {
                font-family: 'Roboto', sans-serif;
                text-align: center;
                background-color: #fff;
                margin: 0;
                display: flex;
                justify-content: center;
                align-items: center;
                height: 100vh;
            }
        
            .certificate {
                border: 10px solid #000;
                max-width: 600px;
                margin: 20px auto;
                padding: 50px;
                background-color: #fff;
                position: relative;
                color: #000;
                text-align: center;
            }
        
            h1 {
                font-weight: 900;
                font-size: 24px;
                margin-bottom: 10px;
            }
        
            h4 {
                font-weight: 900;
                text-align: center;
                font-size: 20px;
            }
        
            h2 {
                font-weight: 700;
                font-size: 18px;
                margin-top: 10px;
                margin-bottom: 5px;
                text-decoration: underline;
            }
        
            h3 {
                font-weight: 700;
                text-decoration: underline;
                font-size: 16px;
                margin-top: 5px;
                margin-bottom: 10px;
            }
        
            p {
                font-weight: 400;
                line-height: 1.5;
            }
        
            img {
                width: 40px;
                height: 40px;
                margin-right: 10px;
                text-align: center;
                align-self: center;
            }
            </style>
        </head>
        <body>
        
        <div class="certificate">
        <h1>Certificate of Completion 🥇</h1>
        <p>This is to certify that</p>
        <h2>${userName}</h2>
        <p>has successfully completed the course on</p>
        <h3>${mainTopic}</h3>
        <p>on ${formattedDate}.</p>
    
        <div class="signature">
            <img src=${logo}>
            <h4>${name}</h4>
        </div>
    </div>
        
        </body>
        </html>`;

        try {
            const postURL = serverURL + '/api/sendcertificate';
            await axios.post(postURL, { html, email }).then(res => {
                navigate('/certificate', { state: { courseTitle: mainTopic, end: formattedDate } });
            }).catch(error => {
                navigate('/certificate', { state: { courseTitle: mainTopic, end: formattedDate } });
            });

        } catch (error) {
            navigate('/certificate', { state: { courseTitle: mainTopic, end: formattedDate } });
        }

    }

    useEffect(() => {
        loadMessages()
        const CountDoneTopics = () => {
            let doneCount = 0;
            let totalTopics = 0;

            jsonData[mainTopic.toLowerCase()].forEach((topic) => {

                topic.subtopics.forEach((subtopic) => {

                    if (subtopic.done) {
                        doneCount++;
                    }
                    totalTopics++;
                });
            });
            const completionPercentage = Math.round((doneCount / totalTopics) * 100);
            setPercentage(completionPercentage);
            if (completionPercentage >= '100') {
                setIsCompleted(true);
            }
        }

        if (!mainTopic) {
            navigate("/create");
        } else {
            if (percentage >= '100') {
                setIsCompleted(true);
            }

            const mainTopicData = jsonData[mainTopic.toLowerCase()][0];
            const firstSubtopic = mainTopicData.subtopics[0];
            if (firstSubtopic) {
                setSelected(firstSubtopic.title);
                setTheory(firstSubtopic.theory);
                setMedia(type === 'video & text course' ? firstSubtopic.youtube : firstSubtopic.image);
                setUrlreference(firstSubtopic.urlreff || []); // Add this line
            }
            firstSubtopic.done = true
            setSelected(firstSubtopic.title)
            setTheory(firstSubtopic.theory)

            if (type === 'video & text course') {
                setMedia(firstSubtopic.youtube);
            } else {
                setMedia(firstSubtopic.image)

            }
            sessionStorage.setItem('jsonData', JSON.stringify(jsonData));
            CountDoneTopics();

        }

    }, []);

    const handleSelect = (topics, sub) => {

        const mTopic = jsonData[mainTopic.toLowerCase()].find(topic => topic.title === topics);
        const mSubTopic = mTopic?.subtopics.find(subtopic => subtopic.title === sub);

        if (mSubTopic.theory === '' || mSubTopic.theory === undefined || mSubTopic.theory === null) {
            if (type === 'video & text course') {

                const query = `${mSubTopic.title} ${mainTopic} in english`;
                const id = toast.loading("Please wait...")
                sendVideo(query, topics, sub, id, mSubTopic.title);

            } else {

                const prompt = `Explain me in long as you can about this subtopic of ${mainTopic} with examples :- ${mSubTopic.title}. Please Strictly Don't Give Additional Resources And Images. `;
                const promptImage = `Example of ${mSubTopic.title} in ${mainTopic}`;
                const id = toast.loading("Please wait...")
                sendPrompt(mainTopic, mSubTopic.title, promptImage, topics, sub, id);

            }
        } else {
            setSelected(mSubTopic.title)

            setTheory(mSubTopic.theory)
            if (type === 'video & text course') {
                setMedia(mSubTopic.youtube);
            } else {
                setMedia(mSubTopic.image)
            }
        }

    };

    async function sendPrompt(mainTopic, mSubTopic, promptImage, topics, sub, id, userPrompt = '') {
        const dataToSend = {
            mainTopic:mainTopic,
            subTopic: mSubTopic,
            documentIds: JSON.parse(sessionStorage.getItem('lastEmbedIdS') || '[]'),
            lastDocsURLs: JSON.parse(sessionStorage.getItem('lastDocsURLs') || '[]'),
            userPrompt: userPrompt
        };
        try {
            const postURL = serverURL + '/api/generatebyids';
            const res = await axios.post(postURL, dataToSend);
            const generatedText = res.data.text;
            if(res.data.urls){
                setUrlreference(res.data.urls);
            }
            const htmlContent = generatedText;
            try {
                const parsedJson = htmlContent;
                sendImage(parsedJson, promptImage, topics, sub, id);
            } catch (error) {
                sendPrompt(mainTopic, mSubTopic, promptImage, topics, sub, id)
            }

        } catch (error) {
            sendPrompt(mainTopic, mSubTopic, promptImage, topics, sub, id)
        }
    }

    async function sendImage(parsedJson, promptImage, topics, sub, id) {
        const dataToSend = {
            prompt: promptImage,
        };
        try {
            const postURL = serverURL + '/api/image';
            const res = await axios.post(postURL, dataToSend);
            try {
                const generatedText = res.data.url;
                const urlreff = res.data.urls;
                // setUrlreference(urlreff);
                sendData(generatedText, parsedJson, topics, sub, id, urlreff);
            } catch (error) {
                const generatedText = 'https://upload.wikimedia.org/wikipedia/commons/c/ca/1x1.png';
                const urlreff = [];
                sendData(generatedText, parsedJson, topics, sub, id);
                // sendImage(parsedJson, promptImage, topics, sub, id)
            }

        } catch (error) {
            const generatedText = 'https://upload.wikimedia.org/wikipedia/commons/c/ca/1x1.png';
            const urlreff = [];
            sendData(generatedText, parsedJson, topics, sub, id);
            // sendImage(parsedJson, promptImage, topics, sub, id)
        }
    }

    async function sendData(image, theory, topics, sub, id, urlreff) {

        const mTopic = jsonData[mainTopic.toLowerCase()].find(topic => topic.title === topics);
        const mSubTopic = mTopic?.subtopics.find(subtopic => subtopic.title === sub);
        mSubTopic.theory = theory
        mSubTopic.image = image;
        mSubTopic.urlreff = urlreff;
        setSelected(mSubTopic.title)

        toast.update(id, { render: "Done!", type: "success", isLoading: false, autoClose: 3000, hideProgressBar: false, closeOnClick: true });
        setTheory(theory)
        if (type === 'video & text course') {
            setMedia(mSubTopic.youtube);
        } else {
            setMedia(image)
        }
        mSubTopic.done = true;
        updateCourse();
    }

    async function sendDataVideo(image, theory, topics, sub, id) {

        const mTopic = jsonData[mainTopic.toLowerCase()].find(topic => topic.title === topics);
        const mSubTopic = mTopic?.subtopics.find(subtopic => subtopic.title === sub);
        mSubTopic.theory = theory
        mSubTopic.youtube = image;
        setSelected(mSubTopic.title)

        toast.update(id, { render: "Done!", type: "success", isLoading: false, autoClose: 3000, hideProgressBar: false, closeOnClick: true });
        setTheory(theory)
        if (type === 'video & text course') {
            setMedia(image);
        } else {
            setMedia(mSubTopic.image)
        }
        mSubTopic.done = true;
        updateCourse();

    }

    async function updateCourse() {
        CountDoneTopics();
        sessionStorage.setItem('jsonData', JSON.stringify(jsonData));
        const dataToSend = {
            content: JSON.stringify(jsonData),
            courseId: courseId
        };
        try {
            const postURL = serverURL + '/api/update';
            await axios.post(postURL, dataToSend);
        } catch (error) {
            updateCourse()
        }
    }

    async function sendVideo(query, mTopic, mSubTopic, id, subtop, userPrompt = '') {
        const dataToSend = {
            prompt: query,
            userPrompt: userPrompt
        };
        try {
            const postURL = serverURL + '/api/yt';
            const res = await axios.post(postURL, dataToSend);

            try {
                const generatedText = res.data.url;
                sendTranscript(generatedText, mTopic, mSubTopic, id, subtop);
            } catch (error) {
                sendVideo(query, mTopic, mSubTopic, id, subtop)
            }

        } catch (error) {
            sendVideo(query, mTopic, mSubTopic, id, subtop)
        }
    }

    async function sendTranscript(url, mTopic, mSubTopic, id, subtop) {
        const dataToSend = {
            prompt: url,
        };
        try {
            const postURL = serverURL + '/api/transcript';
            const res = await axios.post(postURL, dataToSend);

            try {
                const generatedText = res.data.url;
                const allText = generatedText.map(item => item.text);
                const concatenatedText = allText.join(' ');
                const prompt = `Summarize this theory in a teaching way :- ${concatenatedText}.`;
                sendSummery(prompt, url, mTopic, mSubTopic, id);
            } catch (error) {
                const prompt = `Explain me in long as you can about this subtopic of ${mainTopic} with examples :- ${subtop}. Please Strictly Don't Give Additional Resources And Images. `;
                sendSummery(prompt, url, mTopic, mSubTopic, id);
            }

        } catch (error) {
            const prompt = `Explain me in long as you can about this subtopic of ${mainTopic} with examples :- ${subtop}.  Please Strictly Don't Give Additional Resources And Images. `;
            sendSummery(prompt, url, mTopic, mSubTopic, id);
        }
    }

    async function sendSummery(prompt, url, mTopic, mSubTopic, id) {
        const dataToSend = {
            prompt: prompt,
        };
        try {
            const postURL = serverURL + '/api/generate';
            const res = await axios.post(postURL, dataToSend);
            const generatedText = res.data.text;
            const htmlContent = generatedText;
            try {
                const parsedJson = htmlContent;
                sendDataVideo(url, parsedJson, mTopic, mSubTopic, id);
            } catch (error) {
                sendSummery(prompt, url, mTopic, mSubTopic, id)
            }

        } catch (error) {
            sendSummery(prompt, url, mTopic, mSubTopic, id)
        }
    }

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    const handleOpenClose = (keys) => {
        closeQuiz();
        setIsOpen(!isOpen)
        setkey(keys);
    };

    const closeQuiz = () => {
        setShowQuiz(false);
    }

    const defaultMessage = `<p>Hey there! I'm your AI teacher. If you have any questions about your ${mainTopic} course, whether it's about videos, images, or theory, just ask me. I'm here to clear your doubts.</p>`;
    const defaultPrompt = `I have a doubt about this topic :- ${mainTopic}. Please clarify my doubt in very short :- `;

    const loadMessages = async () => {
        try {
            const jsonValue = sessionStorage.getItem(mainTopic);
            if (jsonValue !== null) {
                setMessages(JSON.parse(jsonValue));
            } else {
                const newMessages = [...messages, { text: defaultMessage, sender: 'bot' }];
                setMessages(newMessages);
                await storeLocal(newMessages);
            }
        } catch (error) {
            loadMessages();
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            sendMessage();
        }
    };

    const scrollToTop = () => {
        if (scrollRef.current) {
            scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
        }
    };

    useEffect(() => {
        scrollToTop();
    }, [messages]);
    const sendMessage = async () => {
        if (newMessage.trim() === '') return;

        const userMessage = { text: newMessage, sender: 'user' };
        const updatedMessages = [...messages, userMessage];
        setMessages(updatedMessages);
        await storeLocal(updatedMessages);
        setNewMessage('');

        let mainPrompt = defaultPrompt + newMessage;
        const dataToSend = { prompt: mainPrompt };
        const url = serverURL + '/api/chat';
        try {
            const response = await axios.post(url, dataToSend);

            if (response.data.success === false) {
                sendMessage();
            } else {
                const botMessage = { text: response.data.text, sender: 'bot' };
                const updatedMessagesWithBot = [...updatedMessages, botMessage];
                setMessages(updatedMessagesWithBot);
                await storeLocal(updatedMessagesWithBot);

            }
        } catch (error) {

        }
    };

    async function storeLocal(messages) {
        try {
            sessionStorage.setItem(mainTopic, JSON.stringify(messages));
        } catch (error) {
            sessionStorage.setItem(mainTopic, JSON.stringify(messages));
        }
    }


    const style = {
        "root": {
            "base": "h-full",
            "collapsed": {
                "on": "w-16",
                "off": "w-64"
            },
            "inner": "no-scrollbar h-full overflow-y-auto overflow-x-hidden rounded-none border-black dark:border-white md:border-r  bg-white py-4 px-3 dark:bg-black"
        }
    }

    const renderTopicsAndSubtopics = (topics) => {
        try {
            return (
                <div className='mt-2'>
                    {topics.map((topic) => (
                        <Sidebar.ItemGroup key={topic.title}>
                            <div className="relative inline-block text-left " >
                                <button
                                    onClick={() => handleOpenClose(topic.title)}
                                    type="button"
                                    className="inline-flex text-start text-base font-bold  text-black dark:text-white"
                                >
                                    {topic.title}
                                    <IoIosArrowDown className="-mr-1 ml-2 h-3 w-3 mt-2" />
                                </button>

                                {isOpen && key === topic.title && (
                                    <div className="origin-top-right mt-2 pr-4">
                                        <div
                                            className="py-1"
                                            role="menu"
                                            aria-orientation="vertical"
                                            aria-labelledby="options-menu"
                                        >
                                            {topic.subtopics.map((subtopic) => (
                                                <p
                                                    key={subtopic.title}

                                                    onClick={() => handleSelect(topic.title, subtopic.title)}
                                                    className="flex py-2 text-sm flex-row items-center font-normal text-black dark:text-white  text-start cursor-pointer"
                                                    role="menuitem"
                                                >
                                                    {subtopic.title}
                                                    {subtopic.done === true ? <FaCheck className='ml-2' size={12} /> : <></>}
                                                </p>

                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </Sidebar.ItemGroup>
                    ))}
                </div>
            );
        } catch (error) {
            return (
                <div>
                    {topics.map((topic) => (
                        <Sidebar.ItemGroup key={topic.Title}>
                            <div className="relative inline-block text-left " >
                                <button
                                    onClick={() => handleOpenClose(topic.Title)}
                                    type="button"
                                    className="inline-flex text-start text-base font-bold  text-black dark:text-white"
                                >
                                    {topic.Title}
                                    <IoIosArrowDown className="-mr-1 ml-2 h-3 w-3 mt-2" />
                                </button>

                                {isOpen && key === topic.Title && (
                                    <div className="origin-top-right mt-2 pr-4">
                                        <div
                                            className="py-1"
                                            role="menu"
                                            aria-orientation="vertical"
                                            aria-labelledby="options-menu"
                                        >
                                            {topic.Subtopics.map((subtopic) => (
                                                <p
                                                    key={subtopic.Title}
                                                    onClick={() => handleSelect(topic.Title, subtopic.Title)}
                                                    className="flex py-2 flex-row text-sm items-center font-normal text-black dark:text-white  text-start"
                                                    role="menuitem"
                                                >
                                                    {subtopic.Title}
                                                    {subtopic.done === true ? <FaCheck className='ml-2' size={12} /> : <></>}
                                                </p>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </Sidebar.ItemGroup>
                    ))}
                </div>
            );
        }
    };

    const handleOnRegenerate = async (userPrompt = '') => {
        const id = toast.loading("Regenerating content...");

        const currentTopic = jsonData[mainTopic.toLowerCase()].find(topic =>
            topic.subtopics.some(subtopic => subtopic.title === selected)
        );
        const currentSubtopic = currentTopic.subtopics.find(subtopic => subtopic.title === selected);

        if (type === 'video & text course') {
            const query = `${currentSubtopic.title} ${mainTopic} in english`;
            try {
                await sendVideo(query, currentTopic.title, currentSubtopic.title, id, currentSubtopic.title, userPrompt);
            } catch (error) {
                toast.update(id, { render: "Failed to regenerate content", type: "error", isLoading: false, autoClose: 3000 });
            }
        } else {
            const prompt = `Explain me in long as you can about this subtopic of ${mainTopic} with examples: ${currentSubtopic.title}. Please Strictly Don't Give Additional Resources And Images. `;
            const promptImage = `Example of ${currentSubtopic.title} in ${mainTopic}`;
            try {
                await sendPrompt(mainTopic, currentSubtopic.title, promptImage, currentTopic.title, currentSubtopic.title, id, userPrompt);
            } catch (error) {
                toast.update(id, { render: "Failed to regenerate content", type: "error", isLoading: false, autoClose: 3000 });
            }
        }
    };

    const handleOnEdit = () => {
        setIsEditEnabled(true);
    }

    const handleOnReset = () => {
        if (jsonData && jsonData[mainTopic.toLowerCase()]) {
            const currentTopic = jsonData[mainTopic.toLowerCase()].find(topic =>
                topic.subtopics.some(subtopic => subtopic.title === selected)
            );

            if (currentTopic) {
                const currentSubtopic = currentTopic.subtopics.find(subtopic => subtopic.title === selected);

                if (currentSubtopic) {
                    setTheory(currentSubtopic.theory);
                    const theoryElement = document.getElementById('theory');
                    if (theoryElement) {
                        theoryElement.innerHTML = currentSubtopic.theory;
                    }
                    setMedia(type === 'video & text course' ? currentSubtopic.youtube : currentSubtopic.image);
                }
            }
        }
        setIsEditEnabled(false);
    };

    const handleOnSave = () => {
        const newTheory = [document.getElementById('theory'), document.getElementById('theory1'), document.getElementById('theory2'), document.getElementById('theory3')].find(el => el && el.innerHTML.trim() !== '')?.innerHTML || '';
        console.log('newTheory', newTheory);
        let oldData = { ...jsonData }; // Create a shallow copy of jsonData
        console.log('oldData', oldData);

        if (oldData && oldData[mainTopic.toLowerCase()]) {
            // Find the current topic
            const currentTopic = oldData[mainTopic.toLowerCase()].find(topic =>
                topic.subtopics.some(subtopic => subtopic.title === selected)
            );

            if (currentTopic) {
                // Find the current subtopic
                const currentSubtopic = currentTopic.subtopics.find(subtopic => subtopic.title === selected);
                console.log('currentSubtopic', currentSubtopic);

                if (currentSubtopic) {
                    // Update the theory content
                    currentSubtopic.theory = newTheory;

                    // Update the media content
                    if (type === 'video & text course') {
                        currentSubtopic.youtube = media;
                    } else {
                        currentSubtopic.image = media;
                    }

                    // Save the updated data to sessionStorage
                    sessionStorage.setItem('jsonData', JSON.stringify(oldData));

                    // Update the state
                    // setJsonData(oldData);

                    // Disable editing mode
                    setIsEditEnabled(false);

                    // Show success message
                    toast.success("Content saved successfully!");
                } else {
                    toast.error("Failed to save: Subtopic not found");
                }
            } else {
                toast.error("Failed to save: Topic not found");
            }
        } else {
            toast.error("Failed to save: Course data not found");
        }
    };

    return (
        <>
            {!mainTopic ? <></>
                :
                <div>
                    <div onClick={() => setIsOpenDrawer(true)} className="m-5 fixed bottom-4 right-4 z-40 w-12 h-12 bg-black text-white rounded-full flex justify-center items-center shadow-md dark:text-black dark:bg-white">
                        <IoChatbubbleEllipses size={20} />
                    </div>
                    <div className="flex bg-white dark:bg-black md:hidden pb-10 overflow-y-auto">
                        <div className={`fixed inset-0 bg-black opacity-50 z-50 ${isSidebarOpen ? 'block' : 'hidden'}`} onClick={toggleSidebar}></div>
                        <div className="flex-1 flex flex-col overflow-hidden">

                            <div>
                                <Navbar fluid className='py-3 dark:bg-black bg-white border-black dark:border-white md:border-b'>
                                    <Navbar.Brand className='ml-1'>

                                        {isComplete ?
                                            <p onClick={finish} className='mr-3 underline text-black dark:text-white font-normal'>Certificate</p>
                                            :
                                            <div className='w-7 h-7 mr-3'>
                                                <CircularProgressbar
                                                    value={percentage}
                                                    text={`${percentage}%`}
                                                    styles={buildStyles({
                                                        rotation: 0.25,
                                                        strokeLinecap: 'butt',
                                                        textSize: '20px',
                                                        pathTransitionDuration: 0.5,
                                                        pathColor: storedTheme === "true" ? '#fff' : '#000',
                                                        textColor: storedTheme === "true" ? '#fff' : '#000',
                                                        trailColor: storedTheme === "true" ? 'grey' : '#d6d6d6',
                                                    })}
                                                />
                                            </div>
                                        }

                                        <TruncatedText text={mainTopic} len={6} />
                                    </Navbar.Brand>
                                    <div className='flex md:hidden justify-center items-center'>
                                        <DarkModeToggle className='inline-flex items-center md:hidden' />
                                        {isSidebarOpen ? (
                                            <FiX
                                                onClick={toggleSidebar}
                                                className='mx-2'
                                                size={20}
                                                color={sessionStorage.getItem('darkMode') === 'true' ? 'white' : 'black'}
                                            />
                                        ) : (
                                            <FiMenu
                                                onClick={toggleSidebar}
                                                className='mx-2'
                                                size={20}
                                                color={sessionStorage.getItem('darkMode') === 'true' ? 'white' : 'black'}
                                            />
                                        )}
                                    </div>
                                    <Navbar.Collapse>
                                        <div className='hidden md:flex justify-center items-center mb-2 mt-2'>
                                            <DarkModeToggle />
                                        </div>
                                    </Navbar.Collapse>
                                </Navbar>

                            </div>

                            <Sidebar
                                aria-label="Default sidebar example"
                                theme={style}
                                className={`md:border-r md:border-black md:dark:border-white dark:bg-black fixed inset-y-0 left-0 w-64  bg-white z-50 overflow-y-auto transition-transform transform lg:translate-x-0 ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'}`}
                            >
                                <LogoComponent isDarkMode={storedTheme} />
                                <Sidebar.Items className='mt-6'>
                                    <Sidebar.ItemGroup>
                                        <div className="relative inline-block text-left " >
                                            <button type="button" className="inline-flex text-start text-base w-64 font-bold  text-black dark:text-white" ></button>
                                            {/* <button
                                                onClick={() => htmlDownload()}
                                                type="button"
                                                className="inline-flex text-start text-base w-64 font-bold  text-black dark:text-white"
                                            >
                                                Export Course
                                                <HiDownload className="-mr-1 ml-2 h-3 w-3 mt-2" />
                                            </button> */}
                                        </div>
                                    </Sidebar.ItemGroup>
                                    <br />
                                    <hr />
                                    {jsonData && renderTopicsAndSubtopics(jsonData[mainTopic.toLowerCase()])}

                                </Sidebar.Items>
                            </Sidebar>
                            <div className='mx-5 overflow-y-auto bg-white dark:bg-black'>
                                <p className='font-black text-black dark:text-white text-lg'>{selected}</p>

                                <div className='overflow-hidden mt-5 text-black dark:text-white text-base pb-10 max-w-full'>
                                    {type === 'video & text course' ?
                                        <div>
                                            <YouTube key={media} className='mb-5' videoId={media} opts={optsMobile} />
                                            <div className='text-black dark:text-white' id='theory3' dangerouslySetInnerHTML={{ __html: addTargetBlankToLinks(theory) }} />
                                        </div>

                                        :
                                        <div>
                                            <div className='text-black dark:text-white' id='theory4' dangerouslySetInnerHTML={{ __html: addTargetBlankToLinks(theory) }} />
                                            <img className='overflow-hidden p-10' src={media} alt="Media" />
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='flex flex-row overflow-y-auto h-screen max-md:hidden'>
                        <Sidebar
                            theme={style}
                            aria-label="Default sidebar example">
                            <LogoComponent isDarkMode={storedTheme} />
                            <Sidebar.Items className='mt-6'>
                                <Sidebar.ItemGroup>
                                    <div className="relative inline-block text-left " >
                                        <button type="button" className="inline-flex text-start text-base w-64 font-bold  text-black dark:text-white" ></button>
                                        {/* <button
                                            onClick={() => htmlDownload()}
                                            type="button"
                                            className="inline-flex text-start text-base w-64 font-bold  text-black dark:text-white"
                                        >
                                            Export Course
                                            <HiDownload className="-mr-1 ml-2 h-3 w-3 mt-2" />
                                        </button> */}
                                    </div>
                                </Sidebar.ItemGroup>
                                <br />
                                <hr />
                                {jsonData && renderTopicsAndSubtopics(jsonData[mainTopic.toLowerCase()])}

                            </Sidebar.Items>
                        </Sidebar>
                        <div className='overflow-y-auto flex-grow flex-col'>
                            <Navbar fluid className='py-3 dark:bg-black bg-white border-black dark:border-white md:border-b'>
                                <Navbar.Brand className='ml-1'>
                                    {isComplete ?
                                        <p onClick={finish} className='mr-3 underline text-black dark:text-white font-normal'>Download Certificate</p> :
                                        <div className='w-8 h-8 mr-3'>
                                            <CircularProgressbar
                                                value={percentage}
                                                text={`${percentage}%`}
                                                styles={buildStyles({
                                                    rotation: 0.25,
                                                    strokeLinecap: 'butt',
                                                    textSize: '20px',
                                                    pathTransitionDuration: 0.5,
                                                    pathColor: storedTheme === "true" ? '#fff' : '#000',
                                                    textColor: storedTheme === "true" ? '#fff' : '#000',
                                                    trailColor: storedTheme === "true" ? 'grey' : '#d6d6d6',
                                                })}
                                            />
                                        </div>
                                    }
                                    <TruncatedText text={mainTopic} len={10} />
                                </Navbar.Brand>
                                <Navbar.Collapse>
                                    <div className='hidden md:flex justify-center items-center mb-2 mt-2'>
                                        <DarkModeToggle />
                                    </div>
                                </Navbar.Collapse>
                            </Navbar>
                            <div className='px-5 bg-white dark:bg-black pt-5'>
                                {
                                    showQuiz ?
                                        <>
                                            <div className='flex flex-row justify-between items-center'>
                                                <p className='font-black text-black dark:text-white text-xl'>{selected}</p>
                                                <div className='flex flex-row space-x-2'>
                                                    <FaRegWindowClose onClick={closeQuiz} style={{ cursor: "pointer", backgroundImage: 'linear-gradient(147deg, #880caa, #008da6)' }} className='mx-1' size={24} title="CLose Quiz" />
                                                </div>
                                            </div>
                                            <Quiz questions={quizQuestions} />
                                        </> :
                                        <>
                                            <div className='flex flex-row justify-between items-center'>
                                                <p className='font-black text-black dark:text-white text-xl'>{selected}</p>
                                                <div className='flex flex-row space-x-2' style={{ backgroundImage: 'linear-gradient(147deg, #880caa, #008da6)', borderRadius: '17px', padding: '3px', paddingRight: '8px' }}>
                                                    <TbReload onClick={() => setIsRegenerateModalOpen(true)} className='mx-1' style={{ cursor: "pointer", color: "white" }} size={24} title="Regenerate" />
                                                    <FaRegEdit onClick={handleOnEdit} style={{ cursor: isEditEnabled ? "not-allowed" : "pointer", color: "white" }} className='mx-1' size={24} title="Edit" />
                                                    <RxReset onClick={handleOnReset} style={{ cursor: isEditEnabled ? "pointer" : "not-allowed", color: "white" }} className='mx-1' size={24} title="Reset" />
                                                    <VscSaveAs onClick={handleOnSave} style={{ cursor: isEditEnabled ? "pointer" : "not-allowed", color: "white" }} className='mx-1' size={24} title="Save" />
                                                    <MdOutlineQuiz onClick={generateQuiz} style={{ cursor: "pointer", color: "white" }} className='mx-1' size={24} title="Make Quiz" />
                                                </div>
                                            </div>
                                            <div className='overflow-hidden mt-5 text-black dark:text-white text-base pb-10 max-w-full' contentEditable={isEditEnabled}>
                                                {type === 'video & text course' ?
                                                    <div>
                                                        <YouTube key={media} className='mb-5' videoId={media} opts={opts} />
                                                        <div className='text-black dark:text-white answer' id='theory1' dangerouslySetInnerHTML={{ __html: addTargetBlankToLinks(theory) }} />
                                                        {urlrefference.length > 0 ? (
                                                            <>
                                                                <h1 className='pt-5'><b>Refferences:</b></h1>
                                                                <ol className='pl-10 reffurlboxs'>
                                                                    {urlrefference.map((url, index) => (
                                                                        <li key={index} style={{ listStyleType: 'auto' }} className='reffurlbox'>
                                                                            <a href={url} target="_blank" rel="noreferrer" className='reffurl'>
                                                                                {url}
                                                                            </a>
                                                                        </li>
                                                                    ))}
                                                                </ol>
                                                            </>

                                                        ) : null}
                                                    </div>

                                                    :
                                                    <div>
                                                        <div className='text-black dark:text-white answer' id='theory' dangerouslySetInnerHTML={{ __html: addTargetBlankToLinks(theory) }} />
                                                        <img className='overflow-hidden pl-10 pt-10' src={media} alt="Media" />
                                                        {media == 'https://upload.wikimedia.org/wikipedia/commons/c/ca/1x1.png' ? '' : <p className='pl-10'>Source: <a href={media} target="_blank" rel="noreferrer">{media}</a></p>}
                                                        {urlrefference.length > 0 ? (
                                                            <>
                                                                <h1 className='pt-5'><b>Refferences:</b></h1>
                                                                <ol className='pl-10 reffurlboxs'>
                                                                    {urlrefference.map((url, index) => (
                                                                        <li key={index} style={{ listStyleType: 'auto' }} className='reffurlbox'>
                                                                            <a href={url} target="_blank" rel="noreferrer" className='reffurl'>
                                                                                {url}
                                                                            </a>
                                                                        </li>
                                                                    ))}
                                                                </ol>
                                                            </>

                                                        ) : null}

                                                    </div>
                                                }
                                            </div>
                                        </>
                                }
                            </div>
                        </div>
                    </div>
                    <Drawer open={isOpenDrawer} className='z-50 no-scrollbar bg-white dark:bg-black' position="right" onClose={handleOnClose}>
                        <div style={{ height: 'calc(99% - 50px)', overflowY: 'auto' }} className='no-scrollbar' ref={scrollRef}>
                            {messages.map((msg, index) => (
                                <div key={index} style={{ alignItems: msg.sender === 'user' ? 'flex-end' : 'flex-start', display: 'flex', flexDirection: 'column', }}>
                                    <div style={{ borderBottomLeftRadius: 5, borderBottomRightRadius: 5, borderTopLeftRadius: msg.sender === 'user' ? 5 : 0, borderTopRightRadius: msg.sender === 'user' ? 0 : 5, overflow: 'hidden' }}>
                                        {msg.sender === 'user' ?
                                            <div style={{ backgroundColor: storedTheme === 'true' ? '#F9F9F9' : '#282C34', padding: 16, color: storedTheme === 'true' ? '#01020A' : '#fff', margin: 4 }} className='text-black dark:text-white text-xs' dangerouslySetInnerHTML={{ __html: msg.text }} />
                                            :
                                            <div style={{ backgroundColor: storedTheme === 'true' ? '#01020A' : '#F9F9F9', padding: 16, color: storedTheme === 'true' ? '#fff' : '#01020A', margin: 4 }} className='text-black dark:text-white text-xs ' dangerouslySetInnerHTML={{ __html: msg.text }} />
                                        }
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className='flex flex-row mb-2'>
                            <input value={newMessage} placeholder='Ask Something...' onKeyDown={handleKeyPress} onChange={(e) => setNewMessage(e.target.value)} className='h-12 focus:ring-black focus:border-black border border-black font-normal bg-white rounded-none block w-full dark:bg-black dark:border-white dark:text-white' type="text" />
                            <div onClick={sendMessage} className='h-12 text-black  dark:text-white ml-2 content-center'>
                                <IoSend size={20} />
                            </div>
                        </div>
                    </Drawer>
                    {/* <TbReload 
                        onClick={() => setIsRegenerateModalOpen(true)} 
                        className='mx-1' 
                        style={{ cursor: "pointer", color: "white" }} 
                        size={24} 
                        title="Regenerate" 
                    /> */}

                    <RegenerateModal 
                        isOpen={isRegenerateModalOpen}
                        onClose={() => setIsRegenerateModalOpen(false)}
                        onRegenerate={handleOnRegenerate}
                        mainTopic={mainTopic}
                        selected={selected}
                        type={type}
                    />
                </div>
                
            }
        </>
    );
};


export default Course;